<h2 class="modal-header" mat-dialog-title>Generated JSON :</h2>
<mat-dialog-content class="mat-typography">
  <ngx-json-viewer [json]="data.viewJSON" [expanded]="false"></ngx-json-viewer>
</mat-dialog-content>
